const Theme = {
  body_background_color: 'white',

  header_border_color: '#eee',

  logo_image_url: 'explore.jpg',
  logo_height: 140,

  button_color: '#1B365E',
  button_radius: 15,
  button_border_width: 1,

  text_font: `Arial, Helvetica, sans-serif`,

  title_font: `Arial, Helvetica, sans-serif`,
  title_color: '#1B365E',
  subtitle_color: '#1B365E',

  footer_background_color: '#1B365E',
  footer_border_color: '#eee',
  footer_text_color: 'white',
}

export default Theme
